export default __webpack_public_path__ + "static/media/MartinCrupi.ccfc1c47.jpg";